// Your settings › Appearance (`/settings/appearance`; design spec §9, coverage matrix row 8;
// SETUP-REGROUP moved it out of company Setup, review #18): the theme (light, dark or the
// system's; the account menu no longer repeats it) and the
// sidebar's width and collapsed state, with a reset. Saved on this device only (localStorage,
// by design). Row density is a Phase 5 preference (design spec §10) and is not offered yet.
// SETUP-UX: two `SettingsGroup`s of rows under the 56 px location header; HARDEN-pwa adds a
// third, This device › Install app, where the browser offers it (install-app.tsx).
import {
  Button,
  Segmented,
  SettingsGroup,
  SettingsRow,
  type ThemePreference,
  useShellLayout,
  useTheme,
} from "@companyos/ui";
import { MonitorIcon, MoonIcon, SunIcon } from "lucide-react";
import { InstallAppGroup } from "./install-app";
import { SetupPage } from "./setup-page";

/** The sidebar's default width (design spec §2: 256 px, resizable 224–360). */
const SIDEBAR_DEFAULT = 256;

export function AppearanceScreen() {
  const { preference, setPreference } = useTheme();
  const layout = useShellLayout();
  const changed = layout.sidebarWidth !== SIDEBAR_DEFAULT || layout.sidebarCollapsed;
  return (
    <SetupPage crumbs={["Your settings"]} title="Appearance">
      <SettingsGroup id="theme" title="Theme">
        <SettingsRow label="Theme" hint="Saved on this device only.">
          <Segmented<ThemePreference>
            aria-label="Theme"
            value={preference}
            onValueChange={setPreference}
            options={[
              { value: "light", label: "Light", icon: SunIcon },
              { value: "dark", label: "Dark", icon: MoonIcon },
              { value: "system", label: "System", icon: MonitorIcon },
            ]}
          />
        </SettingsRow>
      </SettingsGroup>
      <SettingsGroup id="sidebar" title="Sidebar">
        <SettingsRow
          label="Width and state"
          hint={
            <span data-slot="sidebar-state">
              {layout.sidebarCollapsed ? "Collapsed" : "Shown"}, {layout.sidebarWidth} px wide
              {changed ? "" : " (the default)"}. Drag the edge to resize; press [ to collapse.
            </span>
          }
        >
          <Button
            variant="secondary"
            size="sm"
            disabled={!changed}
            onClick={() => {
              layout.setSidebarWidth(SIDEBAR_DEFAULT);
              layout.toggleSidebar(false);
            }}
          >
            Reset sidebar
          </Button>
        </SettingsRow>
      </SettingsGroup>
      {/* HARDEN-pwa: install the app on this device (absent when installed or not offered). */}
      <InstallAppGroup />
    </SetupPage>
  );
}
